import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraFormField, SpecraTextarea } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useRef, useState } from 'react';
export function ProgramContextRequest({ context }) {
    const [open, setOpen] = useState(false);
    const [request, setRequest] = useState(`${context}\n\nInformation needed: \nAccountable person: \nFollow-up due date: \nAgreed contact channel: \n\nPlease provide only context approved for this audience. Missing information remains unknown; an end date does not confirm a recompete.\n`);
    const [status, setStatus] = useState('');
    const [copying, setCopying] = useState(false);
    const pending = useRef(false);
    async function copy() {
        if (pending.current) return;
        pending.current = true;
        setCopying(true);
        setStatus('');
        try {
            await navigator.clipboard.writeText(request);
            setStatus('Request context copied. Send it manually through your agreed channel.');
        } catch  {
            setStatus('Could not copy. Select and copy the request text manually, or retry.');
        } finally{
            pending.current = false;
            setCopying(false);
        }
    }
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2",
        "aria-label": "Manual Program context request",
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                "data-testid": Testids.programContext.requestToggle,
                variant: "outline",
                onClick: ()=>setOpen(!open),
                children: open ? 'Close manual request' : 'Prepare manual context request'
            }),
            open && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "Nothing is sent or saved automatically. Add an accountable person, due date and question, then copy for your agreed contact channel. Record the follow-up in the existing Opportunity qualification workflow; completing contact does not confirm the answer."
                    }),
                    /*#__PURE__*/ _jsx(SpecraFormField, {
                        label: "Manual request context",
                        children: /*#__PURE__*/ _jsx(SpecraTextarea, {
                            "data-testid": Testids.programContext.requestText,
                            "aria-label": "Manual request context",
                            value: request,
                            onChange: (e)=>{
                                setRequest(e.target.value);
                                setStatus('');
                            },
                            rows: 12
                        })
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        "data-testid": Testids.programContext.requestCopy,
                        disabled: copying || !request.trim(),
                        onClick: ()=>void copy(),
                        children: copying ? 'Copying…' : 'Copy request context'
                    }),
                    /*#__PURE__*/ _jsx("output", {
                        "data-testid": Testids.programContext.requestStatus,
                        children: status
                    })
                ]
            })
        ]
    });
}
